module.exports = __webpack_public_path__ + "media/images/minci-feder-aei-6cc38efc001d54dbbd85f4d318a709af.png";